"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
addEventListener('DOMContentLoaded', _ => {
    const el = document.querySelector('#webinar');
    if (el) {
        const webinar = new Webinar(el);
        const toggler = webinar.querySelector('#webinar-toggle');
        let openForm;
        let closeForm;
        const initSVGs = () => {
            // cannot be initialised immediately as JavaScript will convert the
            // image elements into SVG elements
            // as we don't want to enter a race condition, we wait until the button is first clicked
            openForm = toggler.querySelector('svg:first-of-type');
            closeForm = toggler.querySelector('svg:last-of-type');
        };
        toggler.addEventListener('click', _ => {
            if (!openForm) {
                initSVGs();
            }
            openForm.classList.toggle('d-none');
            closeForm.classList.toggle('d-none');
            webinar.toggleForm();
        });
    }
});
class Webinar {
    constructor(element) {
        this.token = '';
        this.open = false;
        this.submitted = false;
        this.element = element;
        this.dialog = this.querySelector('#webinar-dialog');
        this.form = element.querySelector('form');
        grecaptcha.ready(() => {
            grecaptcha.execute(window.recaptcha_site_key, { action: 'submission' })
                .then((token) => {
                this.token = token;
            });
        });
        this.closeDialog();
        this.form.addEventListener('submit', ev => {
            ev.preventDefault();
            this.submit();
        });
    }
    toggleForm() {
        this.open = !this.open;
        if (this.open) {
            this.openDialog();
        }
        else {
            this.closeDialog();
        }
    }
    openDialog() {
        this.dialog.style.height = `${this.dialog.offsetHeight || 496}px`;
    }
    closeDialog() {
        this.dialog.style.height = '0px';
    }
    querySelector(selector) {
        return this.element.querySelector(selector);
    }
    submit() {
        if (this.submitted) {
            return;
        }
        this.submitted = true;
        const alt = this.querySelector('#webinar-form-alt');
        alt.style.height = `${this.form.offsetHeight || 480}px`;
        const success = alt.querySelector('div');
        alt.classList.remove('d-none');
        alt.classList.add('d-flex');
        this.form.classList.add('d-none');
        const form = new FormData(this.form);
        form.append('form_type', 'webinar');
        form.append('g-recaptcha-response', this.token);
        fetch('/register-webinar', {
            method: 'POST',
            body: form,
        }).then(response => {
            if (response.ok) {
                alt.querySelector('svg').classList.add('d-none');
                success.classList.remove('d-none');
            }
        });
    }
}
